import type { Me } from "@cloudserver/contracts";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { en } from "./locales/en.js";
import { ru } from "./locales/ru.js";

export const LANGUAGES = ["en", "ru"] as const;
export type Language = (typeof LANGUAGES)[number];

/**
 * The language the panel switches to for a signed-in person, or null to
 * keep the one it has (docs/users.md, "Language"): the person's own choice
 * once they made it; before that the browser's (the detector's).
 */
export function accountLanguage(
  me: Pick<Me, "locale" | "localeChosen"> | null,
  current: string | undefined,
): Language | null {
  if (!me?.localeChosen || current === me.locale) return null;
  return me.locale;
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, ru: { translation: ru } },
    supportedLngs: [...LANGUAGES],
    fallbackLng: "en",
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"] },
  });

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
